module.exports = __webpack_public_path__ + "img/ci.4c54d915.svg";